import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Footer from "./components/Footer";
import './index.css';  // Adjust the path based on your project structure

AgoraRTC.setLogLevel(4);

const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

const Layout = () => {
  const location = useLocation();
  const excludedRoutes = [
    "/privacy",
    "/otp",
    "/terms",
    "/talk",
    "/rate",
    "/videocall",
    "/prime",
    "/audio",
    "/visual",
    "/forgotPass",
    "/contact",
    "/about",
    "/price",
    "/refund",
    "/signup",
    "/wccbuy",
    "/gcbuy",
    "/ecare"
  ]; // Add routes where the footer should not appear

  return (
    <>
      <App />
      {!excludedRoutes.includes(location.pathname) && <Footer />}
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AgoraRTCProvider client={client}>
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  </AgoraRTCProvider>
);
